/* Chicken Dog by LINTEL - No-Pull Harness PDP: gallery (dots/thumbs), colour + size -> variant id, pack picker (real units), brand cart drawer after add, review slider */
(function () {
  var tr = document.querySelector('[data-ckh-track]'), dots = document.querySelector('[data-ckh-dots]'), thumbs = document.querySelector('[data-ckh-thumbs]');
  function imgs() { return tr ? Array.prototype.slice.call(tr.children) : []; }
  function go(k) { if (tr) tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); }
  function upd() {
    if (!tr) return;
    var i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
    if (dots) dots.querySelectorAll('span').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
  }
  if (tr) {
    if (dots) { dots.innerHTML = Array(imgs().length + 1).join('<span></span>'); dots.querySelectorAll('span').forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); }); }
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    upd();
  }
  /* variants */
  var V = []; try { V = JSON.parse(document.querySelector('[data-ckh-variants]').textContent); } catch (e) {}
  var vid = document.querySelector('[data-ckh-vid]'), lab = document.querySelector('[data-ckh-colour]'), atc = document.querySelector('.ckh-atc');
  function val(n) { var c = document.querySelector('input[name="' + n + '"]:checked'); return c ? c.value : null; }
  function sync(scroll) {
    var col = val('ckh-colour'), size = val('ckh-size');
    var v = V.filter(function (x) { return x.option1 === col && x.option2 === size; })[0];
    if (lab) lab.textContent = col;
    if (v && vid) {
      vid.value = v.id;
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }
    if (scroll && tr) { var all = imgs(); for (var k = 0; k < all.length; k++) if ((all[k].alt || '').toLowerCase().indexOf(col.toLowerCase() + ' ') === 0) { go(k); break; } }
  }
  document.querySelectorAll('input[name="ckh-colour"]').forEach(function (i) { i.addEventListener('change', function () { sync(true); }); });
  document.querySelectorAll('input[name="ckh-size"]').forEach(function (i) { i.addEventListener('change', function () { sync(false); }); });
  if (V.length) sync(false);
  /* pack picker */
  var q = document.querySelector('[data-ckh-qty]'), now = document.querySelector('[data-ckh-now]');
  document.querySelectorAll('.ckh-pk input').forEach(function (r) {
    r.addEventListener('change', function () {
      document.querySelectorAll('.ckh-pk').forEach(function (l) { l.classList.toggle('is-on', l.contains(r)); });
      if (q) q.value = r.value;
      if (now) now.textContent = r.dataset.now;
    });
  });
  /* brand cart drawer after any add */
  var pending = false;
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) { if (r && r.ok && !pending) { pending = true; setTimeout(function () { pending = false; if (window.CKH) window.CKH.openCart(); }, 250); } }).catch(function () {});
      }
      return p;
    };
  }
  var form = document.querySelector('form[data-ckh-add]');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]'); btn.disabled = true;
      var fd = new FormData(form); fd.delete('ckh-colour'); fd.delete('ckh-size'); fd.delete('ckh-pack');
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { if (!r.ok) throw new Error('add'); btn.disabled = false; })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
  }
  /* review slider + shop now */
  document.querySelectorAll('[data-ckh-rs]').forEach(function (c) {
    var t = c.querySelector('.ckh-rs__track');
    c.querySelectorAll('.ckh-rs__nav button').forEach(function (b) { b.addEventListener('click', function () { t.scrollBy({ left: +b.dataset.d * t.clientWidth, behavior: 'smooth' }); }); });
  });
  document.querySelectorAll('[data-ckh-top-old]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }); });
})();

/* Chicken Dog additions: "Choose your pack" -> buy box, show more reviews, sticky bar once the buy box is out of view */
(function () {
  function buy() { return document.querySelector('.ckh-ticks') || document.getElementById('ckh-buy'); }
  document.querySelectorAll('[data-ckh-top]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault(); var b = buy();
      if (b) window.scrollTo({ top: b.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
    });
  });
  var more = document.querySelector('[data-ckh-more]'), list = document.querySelector('[data-ckh-rlist]');
  if (more && list) more.addEventListener('click', function () { list.classList.add('is-all'); more.style.display = 'none'; });
  var st = document.querySelector('[data-ckh-sticky]'), form = document.getElementById('ckh-buy');
  if (st && form && 'IntersectionObserver' in window) {
    var seen = false;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) seen = true; st.classList.toggle('is-on', seen && !e.isIntersecting && e.boundingClientRect.top < 0); });
    }).observe(form);
  }
})();


/* Chicken Dog additions: image counter, size guide link -> opens the Size & fit accordion */
(function () {
  var tr = document.querySelector('[data-ckh-track]'), cnt = document.querySelector('[data-ckh-gcount]');
  if (tr && cnt) tr.addEventListener('scroll', function () { var n = tr.children.length, k = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)) + 1; cnt.textContent = k + ' / ' + n; }, { passive: true });
  document.querySelectorAll('[data-ckh-sizeguide]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault(); var d = document.getElementById('ckh-fit');
      if (d) { d.open = true; window.scrollTo({ top: d.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' }); }
    });
  });
})();

/* ===== 10-02 (Edvin): Add to cart NEVER goes to /cart - every add (theme ATC, Kaching ATC, any /cart/add form) opens the CKH brand cart drawer ===== */
(function () {
  if (window.__ckh_atc) return; window.__ckh_atc = 1;
  function open() { if (window.CKH && window.CKH.openCart) return window.CKH.openCart(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 2) return setTimeout(add, 800); /* 10-06: bot check (429) or network -> normal form POST, back to this page (?opencart=1), drawer opens. Never /cart, never an alert */ try { var u = new URL(location.href); u.searchParams.set('opencart', '1'); var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = u.pathname + u.search; f.appendChild(h); } catch (x) {} HTMLFormElement.prototype.submit.call(f); });
    })();
  }, false);
})();

/* Chicken Dog additions: testimonial slider dots + auto-advance */
(function () {
  var tm = document.querySelector('[data-ckh-tm]'); if (!tm) return;
  var t = tm.querySelector('.ckh-tm__track'), d = tm.querySelectorAll('.ckh-tm__dots span'), i = 0;
  function on(k) { d.forEach(function (x, j) { x.classList.toggle('is-on', j === k); }); }
  t.addEventListener('scroll', function () { on(Math.round(t.scrollLeft / Math.max(1, t.clientWidth))); }, { passive: true });
  d.forEach(function (x, k) { x.addEventListener('click', function () { t.scrollTo({ left: k * t.clientWidth, behavior: 'smooth' }); }); });
  setInterval(function () { i = (Math.round(t.scrollLeft / Math.max(1, t.clientWidth)) + 1) % d.length; t.scrollTo({ left: i * t.clientWidth, behavior: 'smooth' }); }, 6000);
})();

/* Chicken Dog harness: welcome-offer countdown (to local midnight, like the source page) */
(function () {
  var cd = document.querySelector('[data-ckh-cd]'); if (!cd) return;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
    var s = Math.max(0, Math.floor((end - now) / 1000));
    cd.querySelector('[data-d]').textContent = '00';
    cd.querySelector('[data-h]').textContent = pad(Math.floor(s / 3600));
    cd.querySelector('[data-m]').textContent = pad(Math.floor(s % 3600 / 60));
    cd.querySelector('[data-s]').textContent = pad(s % 60);
  }
  tick(); setInterval(tick, 1000);
})();

/* 10-06: back from the fallback POST (?opencart=1) -> open the brand cart drawer and clean the URL */
(function () {
  try { var u = new URL(location.href); if (u.searchParams.get('opencart') !== '1') return; u.searchParams.delete('opencart'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { return; }
  var n = 0, t = setInterval(function () { var ok = false; for (var k in window) { if (/^[A-Z]{2,4}$/.test(k) && window[k] && typeof window[k].openCart === 'function') { window[k].openCart(); ok = true; break; } } if (ok || ++n > 40) clearInterval(t); }, 150);
})();
